import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { FieldIconSubText } from '@johnlewispartnership/wtr-ingredients/dist/Forms';
import { Checkbox } from '@johnlewispartnership/wtr-ingredients/ingredients/Checkbox';
import { LabeledControl } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/LabeledControl';
import { CONSENT_FIELD } from '../../../../components/CompetitionsForms/constants';
import styles from '../../CompetitionsForm.module.scss';
const TermsAndConditions = ({ form: { errors, register }, singleClickEntry }) => {
    var _a;
    return (React.createElement("div", { className: classNames(styles.sectionWrapper, styles.spacer, {
            [styles.oneClickHighlighted]: singleClickEntry,
        }) },
        React.createElement(LabeledControl, { control: React.createElement(Checkbox, { name: "termsAndConditions", ref: register(CONSENT_FIELD), value: "consent" }), label: "I consent to my data being processed for this competition and have read and understood the Terms and Conditions. Waitrose will process your personal data as set out in our privacy notice." }),
        errors.termsAndConditions && (React.createElement(FieldIconSubText, { id: "consentProcessingData", text: (_a = errors.termsAndConditions) === null || _a === void 0 ? void 0 : _a.message }))));
};
TermsAndConditions.propTypes = {
    form: propTypes.shape({
        errors: propTypes.objectOf(propTypes.shape({
            ref: propTypes.shape({ scrollIntoView: propTypes.func, focus: propTypes.func }),
            type: propTypes.string,
            message: propTypes.string,
        })),
        watch: () => { },
        register: propTypes.func.isRequired,
    }).isRequired,
    singleClickEntry: propTypes.bool,
};
TermsAndConditions.defaultProps = {
    singleClickEntry: false,
};
export default TermsAndConditions;
//# sourceMappingURL=index.js.map